module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BE - Belgium.e06d7870.svg";